import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-chart-piece",
  "use": "icon-si-glyph-chart-piece-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-chart-piece\" id=\"icon-si-glyph-chart-piece\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>839</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\">\n            <path d=\"M8.392,1.049 C8.043,0.998 7.83,1.016 7.467,1.016 C3.372,1.016 0.043,4.35 0.043,8.446 C0.043,12.542 3.372,15.877 7.467,15.877 C11.561,15.877 14.89,12.542 14.89,8.446 C14.89,8.1 14.934,7.848 14.888,7.517 L7.489,8.478 L8.392,1.049 L8.392,1.049 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M10.375,0.047 L9.43,6.586 L16.043,5.658 C15.638,2.764 13.314,0.466 10.375,0.047 L10.375,0.047 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-chart-piece.svg
// module id = PSmy
// module chunks = 62